import { filterNavigation } from './navigation';
import { Environment } from './environment.types';
import productionEnvironment from './environment.production';

const environment: Partial<Environment> = {
  ...productionEnvironment,
  apiBaseUrl: 'https://dermasensor-qms-api.sierralabs.com/api/',
  siteDomain: 'dermasensor-qms.sierralabs.com',
  navigation: filterNavigation(
    'Dashboard',
    'Training Admin',
    'Risk Management',
    'Documents',
    'CAPA',
    'SCAR',
    'Supplier Management',
    'Products',
    'Teams',
    'Employees',
    'Workflow',
    'Task Types',
    'Templates'
  ),
  productConfig: {
    userNeed: {
      name: 'User Requirement',
      idPrefix: 'UR'
    },
    designInput: {
      name: 'Product Requirements',
      idPrefix: 'PR',
      hideRiskField: true,
      useCustomInfoFields: true
    },
    designOutput: {
      name: 'General Requirements',
      idPrefix: 'REQ',
      useCustomInfoFields: true
    },
    validation: {
      hideTestSteps: true
    },
    verification: {
      hideTestSteps: true
    },
    designSpec: {}
    // validation: { disableRelations: ['userNeeds'] },
  },
  riskConfig: {
    useCustomFields: true
  }
};

export default environment;
